import * as React from "react";
import PropTypes from "prop-types";
import AppState from "nexia_mobile/models/app_state";
import BackboneListener from "nexia_mobile/components/BackboneListener";
import connect from "nexia_mobile/flux_like/store/connect";
import Store from "nexia_mobile/flux_like/store";

class CurrentLocationCollectionProvider extends React.Component {
  static propTypes = {
    appState: PropTypes.instanceOf(AppState).isRequired,
    collectionName: PropTypes.string.isRequired,
    children: PropTypes.func.isRequired, // (collection: Backbone.Collection) => React.Element<any>
    debounceAmount: PropTypes.number,
  };

  render() {
    const { appState, collectionName, children, debounceAmount } = this.props;

    return (
      <BackboneListener listenTo={appState} events={["change:currentLocation"]}>
        {() => (
          <BackboneListener
            listenTo={appState.currentLocation}
            events={[`change:${collectionName}`]}
          >
            {() => {
              const collection = appState.currentLocation
                ? appState.currentLocation.get(collectionName)
                : Store.session
                    .get("locations")
                    .first()
                    .get(collectionName);

              return (
                <BackboneListener
                  listenTo={collection}
                  events={["add", "remove", "reset", "sort", "sync", "change"]}
                  debounceRender={
                    debounceAmount != null ? debounceAmount : true
                  }
                >
                  {() => children(collection)}
                </BackboneListener>
              );
            }}
          </BackboneListener>
        )}
      </BackboneListener>
    );
  }
}

export default connect(
  { appState: "appState" },
  CurrentLocationCollectionProvider
);



// WEBPACK FOOTER //
// ./src/components/CurrentLocationCollectionProvider.jsx